import React, { useEffect, useMemo, useState } from 'react';

import { useNavigationItems } from '@hooks/api';

import getSiteFulfiller from '@utils/getSiteFulfiller';
import { Logo, LogoRGOL, LogoRGOLSmall } from './assets';

import Header from './Header';

export default function HeaderContainer() {
  const { navigationItems } = useNavigationItems();

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [firstName, setFirstName] = useState('');

  const locale = useMemo(() => window?.config?.iso_language_code, []);

  const siteFulfiller = useMemo(() => getSiteFulfiller(), []);

  useEffect(() => {
    const getLoginStatus = async () => {
      const response = await fetch('/v1.1/status/', {
        method: 'HEAD'
      });

      setIsLoggedIn(
        response.headers.get('X-Authorized').toLowerCase?.() === 'true'
      );

      setFirstName(response.headers.get('X-User-First-Name') || '');
    };

    getLoginStatus();
  }, []);

  return (
    <Header
      navigationItems={navigationItems}
      headerLogo={
        <a href="/" className="flex flex-none items-center focus:outline-none">
          {siteFulfiller === 'R-GOL' ? (
            <>
              <LogoRGOL className="hidden h-[24px] shrink-0 lg:block" />
              <LogoRGOLSmall className="block h-[24px] shrink-0 lg:hidden" />
            </>
          ) : (
            <Logo className="h-[24px] w-[118px] shrink-0" />
          )}
        </a>
      }
      isLoggedIn={isLoggedIn}
      firstName={firstName}
      options={{
        locale: locale || 'en-GB'
      }}
    />
  );
}
